import { com } from '@squareup/money-formatter'
const Money = com.squareup.cash.common.moneyformatter.Money
const STANDARD = com.squareup.cash.common.moneyformatter.STANDARD

export interface MoneyUtil {
  formatMoney: (amount?: number, currency?: com.squareup.cash.common.moneyformatter.currency.Currency) => string
}

interface Props {
  locale?: string
  currency?: com.squareup.cash.common.moneyformatter.currency.Currency
}

export const moneyFormatter = (props?: Props): MoneyUtil => {
  const formatMoney = (amount = 0, currency?: com.squareup.cash.common.moneyformatter.currency.Currency): string => {
    const amountAndCurrency = Money.fromBigInt(
      BigInt(amount),
      currency || com.squareup.cash.common.moneyformatter.currency.Currency.USD
    )
    const resolvedLocale = props?.locale ? props?.locale : 'en-US'
    return STANDARD.format(amountAndCurrency, resolvedLocale)
  }

  return { formatMoney }
}

const Currency = com.squareup.cash.common.moneyformatter.currency.Currency

export { Currency }
